import React, { useEffect } from 'react'
import { useSequencer } from 'react-sequencer'
import styled from 'styled-components'

const Wrapper = styled.h1`
  display: flex;
`

const CharWrapper = styled.span`
  transform: ${(props) =>
    props.isPrev
      ? 'translate3d(0,0,0) scale(2)'
      : props.active
      ? 'translate3d(0,0,0) scale(2)'
      : 'translate3d(0,0,0) scale(1)'};
  color: ${(props) =>
    props.isPrev ? '#6fcef5' : props.active ? '#7ae87a' : '#000'};
  transform-origin: 50% 50%;
  transition: transform 0.4s linear, color 0.3s linear;
  margin: 0 10px;
`

const SequencedTitle = () => {
  const [sequencer, api] = useSequencer({
    steps,
    loop: true,
    complete: false,
  })

  useEffect(() => {
    api.play()
  }, [])

  const chars = 'React Sequencer'.split('')

  return (
    <div>
      <Wrapper>
        {chars.map((char, index) => (
          <CharWrapper
            key={index}
            active={index === sequencer.index}
            isPrev={index === sequencer.index - 1}
          >
            {char}
          </CharWrapper>
        ))}
      </Wrapper>
    </div>
  )
}

const steps = Array.apply(null, { length: 15 }).map((item, index) => [
  index,
  200,
])

export default SequencedTitle
